import ProductAvailabilityEmailForm from './ProductAvailabilityEmailForm';

export default ProductAvailabilityEmailForm;


// WEBPACK FOOTER //
// ./src/components/ProductAvailabilityEmailForm/index.ts